export default __webpack_public_path__ + "static/media/warning-small.75b6c5e1.svg";